import { Show, For } from "solid-js";
import { useAdminContext } from "./AdminContext";


export default () => {

    const [adminStore, setAdminStore, actions] = useAdminContext() as any;
    const { editUser, deleteUser, addUser } = actions;
    
    //console.log(adminStore, setAdminStore);
    return <>
    <div><button
            type="button" 
            class="btn btn btn-primary btn-sm"  
            onClick={() => {
        const username = prompt("username", "");
        addUser({username, role: 'student'});
    }}>Add User</button></div>
    <table class="table table-striped  table-hover">
    <thead>
      <tr>
        <th scope="col">Id</th>
        <th scope="col">Username</th>
        <th scope="col">Full name</th>
        <th scope="col">Email</th>
        <th scope="col">Role</th>
        <th scope="col">Auth</th>
        <th scope="col">Actions</th>
      </tr>
    </thead>
    <tbody>
    <For each={adminStore.users}>
        {(user, index) => <tr>
            <td scope="row">{user.id}</td>
            <td>{user.username}</td>
            <td>{user.fullName || ''}</td>
            <td>
                <Show when={user.editing} fallback={user.email}>
                    <input  class="form-control"
                        value={user.emailInput || ''} 
                        onInput={(e) => setAdminStore('users', index(), {emailInput: e.target.value})
                    }/>
                </Show>
            </td>
            <td>
                <Show when={user.editing} fallback={user.role}>
                    <input  class="form-control"
                        value={user.roleInput || ''} 
                        onInput={(e) => setAdminStore('users', index(), {roleInput: e.target.value})
                    }/>
                </Show>
            </td>
            <td>{user.authType}</td>
            <td>
                <Show when={user.editing}>
                    <button
                        type="button" 
                        class="btn btn btn-outline-primary btn-sm" 
                        onClick={() => editUser(index())}>save</button>
                </Show>
                <Show when={!user.editing}>
                    <button 
                        type="button" 
                        class="btn btn btn-outline-info btn-sm" 
                        onClick={() => setAdminStore('users', index(), {    
                        editing: true, 
                        roleInput: user.role,
                        })}>edit</button>
                </Show>
                {' '}
                <button
                    type="button" 
                    class="btn btn btn-outline-danger btn-sm" 
                    onClick={() => {
                if(confirm('Confirm deletion')) deleteUser(user.id)}}>delete</button></td>
        </tr>
        }
    </For>
    </tbody>
  </table>
  </>;
}